import Icon from "@mui/material/Icon"
import MDBox from "components/MDBox"
import MDButton from "components/MDButton"
import MDTypography from "components/MDTypography"

// Sticky workspace footer. The primary action follows the workflow: it moves
// the user forward through the steps and only becomes "Publish" on the final
// step — so publishing is never offered while earlier steps are open.
const StickyActionFooter = ({
  isDirty,
  saving,
  publishing,
  publishedNote,
  isFirstStep,
  isLastStep,
  nextLabel,
  onBack,
  onNext,
  onCancel,
  onSaveDraft,
  onPublish,
}) => (
  <MDBox
    position="sticky"
    bottom={0}
    zIndex={10}
    mt={3}
    px={{ xs: 2, md: 3 }}
    py={2}
    bgColor="white"
    borderRadius="lg"
    shadow="md"
    display="flex"
    justifyContent="space-between"
    alignItems="center"
    flexWrap="wrap"
    gap={2}
    sx={({ palette: { grey } }) => ({
      border: `1px solid ${grey[300]}`,
    })}
  >
    <MDBox display="flex" alignItems="center" gap={0.75} flexWrap="wrap">
      {isDirty ? (
        <>
          <Icon fontSize="small" sx={{ color: "warning.main" }}>
            fiber_manual_record
          </Icon>
          <MDTypography variant="caption" color="warning" fontWeight="medium">
            Unsaved changes
          </MDTypography>
        </>
      ) : (
        <>
          <Icon fontSize="small" sx={{ color: "success.main" }}>
            check_circle
          </Icon>
          <MDTypography variant="caption" color="text">
            All changes saved
          </MDTypography>
        </>
      )}
      {publishedNote && (
        <MDTypography
          variant="caption"
          color="success"
          fontWeight="medium"
          sx={{ ml: 1 }}
        >
          {publishedNote}
        </MDTypography>
      )}
    </MDBox>

    <MDBox
      display="flex"
      gap={1.5}
      alignItems="center"
      flexWrap="wrap"
      justifyContent={{ xs: "stretch", sm: "flex-end" }}
      sx={{
        width: { xs: "100%", sm: "auto" },
        "& > button": { flex: { xs: "1 1 auto", sm: "0 0 auto" } },
      }}
    >
      {!isFirstStep && (
        <MDButton variant="text" color="secondary" onClick={onBack}>
          <Icon sx={{ mr: 0.5 }}>arrow_back</Icon>
          Back
        </MDButton>
      )}
      <MDButton variant="outlined" color="secondary" onClick={onCancel}>
        Cancel
      </MDButton>
      <MDButton
        variant="outlined"
        color="info"
        disabled={saving}
        onClick={onSaveDraft}
      >
        {saving ? "Saving…" : "Save Draft"}
      </MDButton>
      {isLastStep ? (
        <MDButton
          variant="gradient"
          color="success"
          disabled={publishing || saving}
          onClick={onPublish}
        >
          {publishing ? "Publishing…" : "Publish"}
        </MDButton>
      ) : (
        <MDButton variant="gradient" color="info" onClick={onNext}>
          {nextLabel}
          <Icon sx={{ ml: 0.5 }}>arrow_forward</Icon>
        </MDButton>
      )}
    </MDBox>
  </MDBox>
)

export default StickyActionFooter
